export default "__VITE_ASSET__CxRYVMR3__"